import React from 'react';
import { RouteComponentProps } from 'react-router';
import RegisterContainer from '../../containers/RegisterContainer/RegisterContainer';

const RegisterPage: React.FC<RouteComponentProps> = props => {
  return <RegisterContainer {...props} />;
};

export default RegisterPage;
